import { useState } from 'react';
import type { ReactNode } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';

function PageLayout({ children, title }: { children: ReactNode, title?: string }): JSX.Element {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex h-[100dvh] overflow-hidden">
      {/* Sidebar */}
      <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />

      {/* Content area */}
      <div className="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden">
        {/*  Site header */}
        <Header sidebarOpen={sidebarOpen} title={title} setSidebarOpen={setSidebarOpen} />

        <main className="grow [&>*:first-child]:scroll-mt-16 px-4 sm:px-6 lg:px-8 py-8 w-full max-w-[96rem] mx-auto">
          {children}
        </main>
      </div>
    </div>
  );
}

export default PageLayout;
